import { RedoClient } from "@redotech/redo-api-client";
import { AxiosInstance } from "axios";

/** Mirrors SFCC's 10s bound; a hung request would otherwise pin
 *  ensureCoverageFee's shared mutation chain for the page lifetime. */
const CUSTOM_FEE_REQUEST_TIMEOUT_MS = 10_000;

export class BigcommerceServerApiClient {
  private readonly redoClient: RedoClient;

  constructor(
    baseURL = process.env.REDO_BIGCOMMERCE_SERVER_URL ||
      "https://bigcommerce-server.getredo.com",
  ) {
    this.redoClient = new RedoClient(baseURL);
  }

  get client(): AxiosInstance {
    return this.redoClient.client;
  }

  async attachCustomFeeToCart({
    widgetId,
    checkoutId,
    productType,
    feeAmount,
  }: {
    widgetId: string;
    checkoutId: string;
    productType: string;
    feeAmount: number;
  }) {
    const response = await this.client.post(
      `widgets/${widgetId}/checkouts/${checkoutId}/custom-fee`,
      { productType, feeAmount },
      { timeout: CUSTOM_FEE_REQUEST_TIMEOUT_MS },
    );
    return response.data;
  }

  async deleteCustomFeeFromCart({
    widgetId,
    checkoutId,
  }: {
    widgetId: string;
    checkoutId: string;
  }) {
    const response = await this.client.delete(
      `widgets/${widgetId}/checkouts/${checkoutId}/custom-fee`,
      { timeout: CUSTOM_FEE_REQUEST_TIMEOUT_MS },
    );
    return response.data;
  }

  postShoppingEvent(
    { widgetId }: { widgetId: string },
    body: { type: string; checkoutId?: string; phone?: string },
  ): void {
    const url = `${this.redoClient.client.defaults.baseURL ?? ""}/widgets/${encodeURIComponent(
      widgetId,
    )}/events`;
    // This endpoint needs no login. We send no cookies because the server
    // allows any website ("*"), which browsers block if cookies are sent.
    void fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...body, timestamp: new Date().toISOString() }),
      // Keeps sending even if the shopper is leaving the page.
      keepalive: true,
      credentials: "omit",
    }).catch(() => {});
  }
}
